import {Component, Inject, ViewChild} from '@angular/core';
import {UserProfile} from '../../models/user-profile';
import {UserProfileService} from '../../services/user-profile.service';
import {MD_DIALOG_DATA, MdDialog} from '@angular/material';
import {CheckboxTableComponent} from '../../components/checkbox-table/checkbox-table.component';
import {UserProfilesActions} from '../../store/actions/userProfiles.actions';
import {ConfirmComponent} from '../confirm/confirm.component';
import {UserActions} from '../../store/actions/user.actions';
import {Store} from '@ngrx/store';
import {User} from '../../models/user';
import {AdminService} from '../../services/admin.service';
import {SuccessComponent} from '../success/success.component';

@Component({
  selector: 'app-user-profile-modal',
  templateUrl: './user-profile-modal.component.html',
  styleUrls: ['./user-profile-modal.component.scss']
})
export class UserProfileModalComponent {

  loading: number;
  profile: UserProfile;
  currentUser: User;
  editMode: boolean;

  @ViewChild('checkboxTable') checkboxTable: CheckboxTableComponent;

  /**
   * Initialize variables and load data
   * @param {UserProfileService} userProfileService
   * @param {UserProfilesActions} userProfilesActions
   * @param {MdDialog} mdDialog
   * @param {Store<any>} store
   * @param {AdminService} adminService
   * @param {UserActions} userActions
   * @param data
   */
  constructor(private userProfileService: UserProfileService,
              private userProfilesActions: UserProfilesActions,
              private mdDialog: MdDialog,
              private store: Store<any>,
              private adminService: AdminService,
              private userActions: UserActions,
              @Inject(MD_DIALOG_DATA) public data: any) {

    /**
     * Number of resource to fetch
     * @type {number}
     */
    this.loading = 1;

    /**
     * If there is a paramter id then fetch the user profile from the API
     */
    if (data.id) {
      this.userProfileService.getUserProfileById(data.id).subscribe((userProfile) => {
        this.profile = userProfile;
        this.loading--;
      });
    } else {
      /**
       * Else create an empty user profile
       * @type {UserProfile}
       */
      this.profile = new UserProfile({});
      this.loading--;
    }

    /**
     * Get current user from the store
     */
    this.store.select('userState').subscribe(user => this.currentUser = user);

    /**
     * Check the rights for this component
     */
    this.adminService.init().subscribe(() => {
      this.editMode = this.adminService.can('Admin Panel', 'Edit');
    });
  }

  /**
   * When a privilege changes, update the profile's privilege
   */
  userPrivilegesUpdated() {
    this.profile.privileges = this.checkboxTable.settablePrivileges.filter(privilege => privilege.checked === true);
  }

  /**
   * Save the user profile with an API call
   */
  saveUserProfile() {
    const profile = new UserProfile(this.profile);
    profile.privileges = this.checkboxTable.settablePrivileges.filter(privilege => privilege.checked === true);
    this.userProfileService.updateUserProfile(profile).subscribe(profiles => {
      this.userProfilesActions.setUserProfiles(profiles);
      this.userActions.updateProfile(profiles.find(p => p.id === profile.id));
      this.mdDialog.closeAll();
      this.mdDialog.open(SuccessComponent, {data: {message: 'Profile has been saved'}});
    });
  }

  /**
   * Delete the user profile with an API call
   */
  deleteProfile() {
    const title = 'Do you want to delete this profile ?';
    const message = 'Are you sure to delete this profile ?';
    this.mdDialog.open(ConfirmComponent, {data: {title: title, message: message}}).afterClosed().subscribe(res => {
      if (res === true) {
        this.userProfileService.deleteProfile(this.profile).subscribe(profiles => {
          this.userProfilesActions.setUserProfiles(profiles);
          this.mdDialog.closeAll();
          this.mdDialog.open(SuccessComponent, {data: {message: 'Profile has been deleted'}});
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modals/user-profile-modal/user-profile-modal.component.ts